<template>
  <div>
    <div class="page-title">
      <h3>Настройки статистики</h3>
    </div>
    <Loader v-if="loading" />
    <div class="row" id="sg" v-else>
      <div class="setting">
        <p>Период по умолчанию:</p>
        <select style="display: block" v-model="choosed" ref="period">
          <option v-for="d of period" :key="d.id" :data-id="d.id">
            {{ d.title }}
          </option>
        </select>
      </div>
      <div class="setting">
        <p>Отряд по умолчанию:</p>
        <select style="display: block" v-model="tag" ref="tag">
          <option v-for="s of squads" :key="s">{{ s }}</option>
        </select>
      </div>
      <div class="input-field setting">
        <p>Ваш никнейм:</p>
        <input
          type="text"
          id="autocomplete-input"
          class="autocomplete"
          autocomplete="off"
          v-model.trim="nick"
          ref="nick"
        />
      </div>
      <div class="setting">
        <p>Цветовая палитра:</p>
        <div class="switch">
          <label>
            <b>Светлая</b>
            <input type="checkbox" ref="theme" :checked="theme" />
            <span class="lever"></span>
            <b>Темная</b>
          </label>
        </div>
      </div>
      <a class="waves-effect waves-light btn" @click.prevent="setLocalInfoStore"
        >Сохранить</a
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Formatter from "@/utils/Formatter";
export default {
  name: "Home",
  data: () => ({
    tag: "[FNX]",
    squads: [],
    nicknames: {},
    loading: true,
    choosed: "За все время",
    period: [],
    tab: null,
    theme: "",
    nick: "",
  }),
  async mounted() {
    if (this.$route.query.msg === "setnick") {
      M.toast({ html: "Выберите свой никнейм!" });
    }
    this.choosed = this.getInfo().period;
    this.tag = this.getInfo().tag;
    this.theme = this.getInfo().theme;
    this.nick = this.getInfo().nick;
    if (!this.playersStats.length) {
      await this.$store.dispatch("getPlayersInfo");
    }
    for (let key in this.playersStats) {
      let pName = this.playersStats[key].name;
      this.nicknames[pName] = null;
    }

    if (!this.squadsStats.length) {
      await this.$store.dispatch("getSquadsInfo");
    }
    for (let key in this.squadsStats) {
      this.squads.push(this.squadsStats[key].prefix);
    }
    this.squads.sort();
    this.squads.unshift("[Одиночки]");
    if (!this.rotations.length) {
      await this.$store.dispatch("getRotationsInfo");
    }
    for (let key in this.rotations) {
      this.period.push({
        id: Number(key),
        title: `${Formatter.formatDate(this.rotations[key].startDate)} - ${
          this.rotations[key].endDate
            ? Formatter.formatDate(this.rotations[key].endDate)
            : " по настоящий момент."
        }`,
        endDate: this.rotations[key].endDate,
        startDate: this.rotations[key].startDate,
      });
    }
    this.period.push({
      id: this.rotations.length,
      title: "За все время",
    });
    this.period.reverse();
    this.loading = false;
    setTimeout(() => {
      var elems = document.querySelectorAll(".autocomplete");
      var instances = M.Autocomplete.init(elems, {
        data: this.nicknames,
        onAutocomplete: this.changeNameModel,
      });
    }, 200);
  },
  methods: {
    ...mapGetters(["getInfo"]),
    setLocalInfoStore() {
      const newInfo = {};
      newInfo.theme = this.$refs.theme.checked;
      newInfo.tag = this.$refs.tag.value;
      newInfo.period = this.$refs.period.value;
      newInfo.nick = this.$refs.nick.value;
      this.theme = this.$refs.theme.checked;
      this.$store.dispatch("updateLocalInfo", newInfo);
      this.$emit("reloadSidebar");
      M.toast({ html: "Настройки сохранены!" });
    },
    changeNameModel(newNick) {
      this.nick = newNick;
    },
  },
  computed: {
    ...mapState(["rotations", "squadsStats", "playersStats"]),
  },
};
</script>
